export class UnavailableError extends Error {
  constructor() {
    super('react-native-biometrics is not installed correctly.');
  }
}
